export const weight = {
    100: 300,
    200: 600,
    300: 700,
    400: 800
}